import React from 'react';
import ABSErrorPage from '../ABSErrorPage';
import { connect } from 'dva';
import emitter, { EventName } from '../../utils/eventUtils';

class ErrorBoundary extends React.Component<any, any> {
  private message = '';

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount() {
    this.message = '';
    emitter.addListener(EventName[206], this.onRefresh);
  }

  componentWillUnmount() {
    this.message = '';
    emitter.removeListener(EventName[206], this.onRefresh);
  }

  componentDidCatch(error: any, info: any) {
    this.setState(
      {
        hasError: true
      },
      () => {
        this.props.dispatch({
          type: 'global/pageLog',
          payload: {
            url: window.location.pathname + '/' + window.location.hash,
            title: document.title,
            error_msg: error.toString(),
            info: info
          }
        });
      }
    );
    console.log(error); // 用于黑屏报错定位，请勿删除
  }

  onRefresh = message => {
    this.message = message;
    this.setState({ hasError: true });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <ABSErrorPage message={this.message} />
        </div>
      );
    }

    return this.props.children;
  }
}
const mapStateToProps = ({ global }) => {
  return {};
};

export default connect(mapStateToProps)(ErrorBoundary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSErrorBoundary/index.tsx